var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 2H14.0922C14.2763 2 14.4256 2.14924 14.4256 2.33333C14.4256 2.39134 14.4104 2.44835 14.3816 2.49871L11.9999 6.66667L14.3816 10.8346C14.4729 10.9945 14.4174 11.1981 14.2576 11.2894C14.2072 11.3182 14.1502 11.3333 14.0922 11.3333H2.66659V14.6667H1.33325V2Z",
    fill: "#FF4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagRed);
export default __webpack_public_path__ + "static/media/flag-red.254fc8abfe958d3b0a1f0eb428bc9d90.svg";
export { ForwardRef as ReactComponent };